import { Environment, getConfiguration } from "../../config";
import { ApiClient } from "./ApiClient";

export class AuthKeyClient extends ApiClient {
	private readonly authKey: string;

	constructor(env?: Environment, apiKey?: string) {
		if (!process.env.REACT_APP_SENDUM_AUTH_KEY) {
			if (!apiKey) {
				throw new Error("REACT_APP_SENDUM_AUTH_KEY is not set");
			}
		}

		const config = getConfiguration(env);

		super({
			baseApiUrl: config.headerAuthWidgetsApiUrl,
			apiVersion: config.headerAuthWidgetsApiVersion,
			basePath: config.baseApiPath,
		});

		this.authKey = ((apiKey && process.env[apiKey]) ? process.env[apiKey] : apiKey || process.env.REACT_APP_SENDUM_AUTH_KEY) as string;
	}

	async appendHeaders(): Promise<HeadersInit> {
		return Promise.resolve({
			"auth-key": this.authKey,
		});
	}

}
